import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import RootStore, { ROOT_STORE } from 'src/stores/rootStore';
import nl2br from 'react-nl2br';

interface IConfirmPopupComponentProps {
  id: string;
  title?: string;
  message?: string;
  actionString?: string;
  cancelString?: string;
  onSubmit?: () => void;
  onCancel?: () => void;
}

interface IConfirmPopupComponentInjectedProps {
  [ROOT_STORE]: RootStore;
}

export const ConfirmPopupComponent: React.FC<IConfirmPopupComponentProps> = inject(ROOT_STORE)(observer(({ id, title, message, actionString, cancelString, onCancel, onSubmit, ...props }) => {

  const { rootStore: { popupStore } } = props as IConfirmPopupComponentInjectedProps;
  const { t } = useTranslation();
  // tslint:disable-next-line: variable-name
  const _actionString = actionString ?? t('shared.actionString');
  // tslint:disable-next-line: variable-name
  const _cancelString = cancelString ?? t('shared.cancelString');

  const onClickCancel = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onCancel !== undefined) {
      onCancel();
    };
    popupStore.destroy(id)
  }
  const onClickOk = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (onSubmit !== undefined) {
      onSubmit();
    };
    popupStore.destroy(id)
  }

  return (
      <div className='popup-wrap' style={{ top: '49%', transform: 'translateY(-50%)' }}>
        <p className='popup-logo'>commtown</p>
        {title !== undefined && <p className='popup-txt1'>{nl2br(title)}</p>}
        {message !== undefined && <p className='popup-txt2'>{nl2br(message)}</p>}
        <p className='popup-btn btn-twin'>
          <a onClick={onClickCancel} className='btn-gy'>{_cancelString}</a>
          <a onClick={onClickOk} className='btn-bk'>{_actionString}</a>
        </p>
      </div>
  )
}));


// WEBPACK FOOTER //
// ./src/components/layout/popup/confirm.tsx